
import Field from "@/components/crud/fields/FieldMixin.vue";
import Vue from "vue";

export default Vue.extend({
  name: "KSelect",
  mixins: [Field],
  inheritAttrs: false,
});
